import axios from "axios";
import { API_BASE_URL } from "../common/config.js";
import authHeader from "./auth-header";

const getAuthHeader = () => {
  return authHeader();
};

const createPayment = async (environmentId, planId, domainCount, language = 'en') => {
  const response = await axios.post(
    API_BASE_URL + "/api/payments/create-payment",
    { 
      environmentId,
      planId,
      domainCount,
      language
    },
    { headers: getAuthHeader() }
  );
  return response.data;
};

const checkPaymentStatus = async (paymentId) => {
  const response = await axios.get(
    API_BASE_URL + `/api/payments/payment-status/${paymentId}`,
    { headers: getAuthHeader() }
  );
  return response.data;
};

const getSubscriptionStatus = async () => {
  const response = await axios.get(
    API_BASE_URL + "/api/payments/check-subscription",
    { headers: getAuthHeader() }
  );
  return response.data;
};

const getPlanById = async (planId) => {
  const response = await axios.get(
    API_BASE_URL + `/api/subscription-plans/${planId}`,
    { headers: getAuthHeader() }
  );
  return response.data;
};

const PaymentService = {
  createPayment,
  checkPaymentStatus,
  getSubscriptionStatus,
  getPlanById,
};

export default PaymentService;
